import React from 'react'
import DfbRte from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_rte'
import DfbImage from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_image'
import DfbAnchor from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_anchor'
import { useTranslations } from '@dfb/gatsby-dfb-theme/src/hooks/useTranslations'
import { Transformation } from 'cloudinary-react'

const CTextimage = (props) => {
  const t = useTranslations()

  let layoutClasses = ''
  let imageLayoutClasses = ''

  let crop = 'fill'

  let imageWidth = 1024
  let imageHeight = 576
  let aspectRatio = '16:9'

  if (props.data.brand === 'employer-branding') {
    aspectRatio = '1:1'
    imageHeight = 1024
  }

  if (props.data.layout.includes('portrait')) {
    crop = 'pad'
    aspectRatio = '3:4'
    imageLayoutClasses = 'dfb-Image--3To4Ratio'
    imageWidth = 768
    imageHeight = 1024
  }

  if (props.data.layout === 'text-right' || props.data.layout === 'text-right-portrait') {
    layoutClasses = 'c-TextImage--reverse'
  }

  if (props.data.layout === 'text-bottom') {
    layoutClasses = 'c-TextImage--text-bottom'
  }

  return (
    <div className={`c-TextImage ${layoutClasses}`}>
      <div className="c-TextImage-textContainer">
        <div className="c-TextImage-text">
          {props.data.text && <DfbRte text={props.data.text} add_class="c-TextImage-rte" />}
          {props.data.anchor && props.data.anchor !== '//-/id-1' && props.data.anchor !== '//-/id-INVALID-' && (
            <DfbAnchor
              tagName="a"
              secondary={true}
              link={props.data.anchor}
              text={t('dfb_anchor.morelink')}
              add_class="c-TextImage-anchor"
            />
          )}
        </div>
        {props.data.image[0] && (
          <figure className="c-TextImage-imageWrapper">
            {props.data.image[0].src && (
              <DfbImage image={props.data.image[0]} add_class={`c-TextImage-image ${imageLayoutClasses}`} aspect_ratio={aspectRatio}>
                <Transformation
                  crop={crop}
                  gravity={crop === 'fill' ? 'faces:center' : undefined}
                  width={imageWidth}
                  height={imageHeight}
                  quality="auto"
                  fetchFormat="auto"
                />
              </DfbImage>
            )}
            {props.data.image[0].copyright && <figcaption className="c-TextImage-figcaption">{props.data.image[0].copyright}</figcaption>}
          </figure>
        )}
      </div>
    </div>
  )
}

export default CTextimage
